"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Carousel_1 = __importDefault(require("./components/Carousel"));
exports.default = Carousel_1.default;
